import deburr from 'lodash/deburr';

/**
 * Making text lower case and calling deburr from lodash for normalization
 * @param text text to be normalized
 * @returns normalized text
 */
export const normalizeStr = (text: string) => deburr(text.toLowerCase());
